/**
 * Blood-pool overlay. One tint sprite per map tile; per-frame alpha reflects
 * the tile's blood level. Dark crimson so it reads as "old blood pooling"
 * rather than a bright hazard.
 */

import { Container, Sprite, Texture } from 'pixi.js';
import type { BloodMap } from '../sim/blood';

const TINT = 0x6a1010;

export class BloodLayer {
  readonly container: Container;
  private sprites: Sprite[] = [];
  private tileSize = 0;
  private width = 0;

  constructor() {
    this.container = new Container();
  }

  build(width: number, height: number, tileSize: number): void {
    this.container.removeChildren();
    this.sprites.length = 0;
    this.width = width;
    this.tileSize = tileSize;
    for (let y = 0; y < height; y++) {
      for (let x = 0; x < width; x++) {
        const s = new Sprite(Texture.WHITE);
        s.setSize(tileSize, tileSize);
        s.tint = TINT;
        s.alpha = 0;
        s.x = x * tileSize;
        s.y = y * tileSize;
        this.container.addChild(s);
        this.sprites.push(s);
      }
    }
  }

  update(bmap: BloodMap): void {
    const src = bmap.blood;
    for (let i = 0; i < src.length; i++) {
      const v = src[i] ?? 0;
      // Blood levels 0..255 → alpha 0..0.7 (never fully opaque).
      const s = this.sprites[i]!;
      if (v === 0) {
        s.alpha = 0;
      } else {
        s.alpha = Math.min(0.72, v / 255 * 0.85);
      }
    }
    void this.width;
    void this.tileSize;
  }
}
